import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import './css/HeaderMain.scss';

function HeaderApplicant({applicant})  {
    
    return (
        <Container className="header">
            <Row>
                <Col><h1>{applicant ? applicant.lastName +", "+ applicant.firstName +" "+ applicant.middleName:"Applicant Not Found"}</h1></Col>
            </Row>
        </Container>
    ); 

}

export default HeaderApplicant;